import { ThemeProvider as JSSThemeProvider } from 'features/sharedModules/styles/components/styles.js';

const ThemeProvider = ({ theme, children }) => {
  return <JSSThemeProvider theme={theme}>{children}</JSSThemeProvider>;
};

export default ThemeProvider;
